import { observer } from 'mobx-react-lite';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { combineValidators, isRequired } from 'revalidate';
import { Form } from 'semantic-ui-react';

import DateInput from '../../../app/common/form/DateInput';
import { FrameFiltersFormValues } from '../../../app/models/frame';
import { RootStoreContext } from '../../../app/stores/rootStore';

const validate = combineValidators({
  reservationDate: isRequired({ message: '来塔希望日は必須入力です' }),
});

const FrameFilters: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { setFrameFilters } = rootStore.frameStore;

  const [formValues, setFormValues] = useState(new FrameFiltersFormValues());

  useEffect(() => {
    setFormValues(new FrameFiltersFormValues());
    setFrameFilters(new FrameFiltersFormValues());
  }, [setFrameFilters]);

  const handleFinalFormSubmit = (value: any) => {
    const filters = new FrameFiltersFormValues();
    if (value !== null) {
      filters.reservationDate = value;
      setFrameFilters(filters);
    } else {
      filters.reservationDate = undefined;
      setFrameFilters(filters);
    }
  };

  return (
    <Fragment>
      <FinalForm
        validate={validate}
        initialValues={formValues}
        onSubmit={handleFinalFormSubmit}
        render={() => (
          <Form>
            <Form.Group widths='16'>
              <Field
                name='reservationDate'
                value={formValues.reservationDate}
                component={DateInput}
                inputOnChange={handleFinalFormSubmit}
              />
            </Form.Group>
          </Form>
        )}
      />
    </Fragment>
  );
};

export default observer(FrameFilters);
